import { useEffect } from 'react';
import { Provider, useMobileContext } from './Provider';

const Mobile = (props) => {
    return <Provider {...props}>
        {props.children}
    </Provider>
};

const useKeyboardHelper = (identifier) => {
    const mobile = useMobileContext();

    useEffect(() => {
        return () => {
            if (mobile && identifier) {
                mobile.showNav(identifier);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!mobile) {
        return {
            hideNav: () => {},
            showNav: () => {},
        };
    }

    return {
        hideNav: () => identifier && mobile.hideNav(identifier),
        showNav: () => identifier && mobile.showNav(identifier),
    };
}

const useStatusBarColour = (colour) => {
    const {setStatusBarColour} = useMobileContext();

    useEffect(() => {
        setStatusBarColour(colour);

        return () => setStatusBarColour(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colour]);
}

export default Mobile;

export {
    useMobileContext as useMobile,
    useKeyboardHelper,
    useStatusBarColour,
}
